<template>
  <div
    class="main demo-split"
    id="aa"
    :class="{ mapscreen: $store.state.isMapScreen }"
  >
    <Split v-model="split" min="0" max="400">
      <div slot="left" ref="left" style="height: 100%">
        <monitor-tree
          ref="fleetTree"
          modal="locate"
          @selectCarList="reCarList"
        ></monitor-tree>
      </div>
      <div slot="right" ref="right" style="height: 100%">
        <div id="left_right" @click="showHide">
          <Icon v-if="split == 0" type="md-arrow-dropright" />
          <Icon v-else type="md-arrow-dropleft" />
        </div>
        <div id="locateTools">
          <ButtonGroup vertical>
            <Button
              :type="isSearch ? 'primary' : 'default'"
              icon="ios-search"
              title="搜索位置"
              @click="isSearch = !isSearch"
            ></Button>
            <Button
              :type="isAreaFind ? 'primary' : 'default'"
              icon="md-map"
              title="区域查询设备"
              @click="areaCar"
            ></Button>
            <Button
              :type="isYun ? 'primary' : 'default'"
              icon="md-cloudy"
              title="卫星云图"
              @click="reYun"
            ></Button>
            <Button
              :type="isLukuang ? 'primary' : 'default'"
              icon="md-car"
              title="路况信息"
              @click="reLuKuang"
            ></Button>
            <Button
              :type="isDrawRule ? 'primary' : 'default'"
              icon="ios-paper-plane"
              title="测距"
              @click="reCeju"
            ></Button>
            <Button
              icon="md-pin"
              title="标注点"
              @click="$refs.pointList.open()"
            ></Button>
            <Button
              icon="md-git-merge"
              title="路线规划"
              @click="$refs.lineList.open()"
            ></Button>
            <Button
              icon="ios-disc"
              title="电子围栏"
              @click="$refs.fenceList.open()"
            ></Button>
          </ButtonGroup>
        </div>
        <g-map ref="postDevice" :aaaa="mapshuxing"></g-map>
      </div>
    </Split>
  </div>
</template>
<script>
import monitorTree from "./locateToolCarPerson.vue";
import gMap from "../map/locate.vue";
import iconWindow from "./iconWindow";
import myVideo from "./com/locateVideo.vue";
import quyuchache from "./quyuchache.vue";
export default {
  props: ["isToCenter"],
  data() {
    return {
      split: "260",
      leftLoteData: [],
      mapshuxing: {
        iconWindow: 1,
      },
    };
  },
  computed: {
    litenIsMapScreen() {
      return this.$store.state.isMapScreen;
    },
  },
  components: {
    monitorTree,
    gMap,iconWindow,myVideo,quyuchache
  },
  methods: {
    showHide() {
      if (this.split == 0) {
        this.split = "260";
        this.$refs.left.style.display = "block";
      } else {
        this.split = 0;
        this.$refs.left.style.display = "none";
      }
    },
    setHight() {},
    reCarList(v, isToCenter) {
      this.$refs.postDevice.websockToLocate(v, isToCenter);
    },
  },
  mounted() {
    //this.setHight();
    if (localStorage.getItem("Split1") == null) {
      // this.split = 0.1;
    } else {
      // this.split = Number(localStorage.getItem("Split1"));
    }
  },
  watch: {
    litenIsMapScreen(v) {
      if (v) {
        var height = window.screen.height;
        this.$refs.right.style.height = height - 5 + "px";
      } else {
        setTimeout(() => {
          var height = document.body.clientHeight;
          this.$refs.right.style.height = height - 55 + "px";
        }, 200);
      }
    },
  },
  deactivated() {
    console.log("离开页面了");
  },
};
</script>
<style>
/*去除百度地图版权*/
.anchorBL {
  display: none;
}

.demo-split {
  position: relative;
  border: 1px solid #dcdee2;
}
#left_right {
  position: absolute;
  left: 0;
  top: 48%;
  background: #333;
  width: 18px;
  line-height: 60px;
  z-index: 18;
  color: #fff;
  font-size: 18px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  opacity: 0.3;
}
#left_right:hover {
  opacity: 0.5;
}
.mapscreen {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 6666;
  width: 100%;
  height: 100% !important;
  background: #f5f5f5;
  padding-top: 0 !important;
}
#locateTools {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 22;
}
#locateSearch {
  position: absolute;
  top: 10px;
  left: 50px;
  z-index: 22;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/allLocate.vue